import request from '@/utils/request'

// 查询产品中心商品列表
export function listProductItems(data) {
  return request({
    url: '/crmProductCenter/list',
    method: 'post',
    data: data
  })
}

// 查询产品中心商品详情
export function getProductItemDetail(id) {
  return request({
    url: `/crmProductCenter/detail/${id}`,
    method: 'get'
  })
}

// 保存产品中心商品，包含商品主档、交付与成本构成、交付模板
export function saveProductItem(data) {
  return request({
    url: '/crmProductCenter/save',
    method: 'post',
    data: data
  })
}

// 删除产品中心商品
export function removeProductItem(id) {
  return request({
    url: `/crmProductCenter/remove/${id}`,
    method: 'post'
  })
}
